import { useRef, useState } from "react";
import { Camera, ImagePlus, Loader2, X } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg, fileUrl } from "@/lib/api";
import { fmtDateTime } from "@/lib/format";

export default function PhotoUploader({ value, onChange, max = 5, testid = "photo-uploader" }) {
  const camRef = useRef(null);
  const galRef = useRef(null);
  const [busy, setBusy] = useState(0);

  const upload = async (files) => {
    const list = Array.from(files || []).slice(0, max - value.length);
    if (!list.length) return;
    setBusy(list.length);
    const done = [];
    for (const f of list) {
      try {
        const fd = new FormData();
        fd.append("file", f);
        const { data } = await api.post("/files", fd);
        done.push(data);
      } catch (e) {
        toast.error(`Upload gagal: ${errMsg(e)}`);
      }
    }
    setBusy(0);
    onChange([...value, ...done]);
  };

  const full = value.length >= max;
  return (
    <div data-testid={testid}>
      <div className="grid grid-cols-3 gap-2 sm:grid-cols-5">
        {value.map((f) => (
          <div key={f.id} className="group relative aspect-square overflow-hidden rounded-md border-2 border-ink bg-zinc-100" data-testid={`${testid}-thumb`}>
            <img src={fileUrl(f.id)} alt="bukti" className="h-full w-full object-cover" />
            <div className="absolute inset-x-0 bottom-0 bg-ink/80 px-1 py-0.5 text-[9px] text-white">{fmtDateTime(f.uploaded_at)}</div>
            <button type="button" onClick={() => onChange(value.filter((x) => x.id !== f.id))} data-testid={`${testid}-remove`}
              className="absolute right-1 top-1 grid h-6 w-6 place-items-center rounded-full bg-white text-ink shadow"><X className="h-3.5 w-3.5" /></button>
          </div>
        ))}
        {busy > 0 && Array.from({ length: busy }).map((_, i) => (
          <div key={`b${i}`} className="grid aspect-square place-items-center rounded-md border-2 border-dashed border-zinc-300"><Loader2 className="h-5 w-5 animate-spin" /></div>
        ))}
      </div>
      {!full && (
        <div className="mt-2 grid grid-cols-2 gap-2">
          <button type="button" onClick={() => camRef.current?.click()} data-testid={`${testid}-camera-btn`}
            className="press flex h-12 items-center justify-center gap-2 rounded-md bg-ink text-sm font-semibold text-white hover:bg-zinc-800">
            <Camera className="h-4 w-4" /> Ambil Foto
          </button>
          <button type="button" onClick={() => galRef.current?.click()} data-testid={`${testid}-gallery-btn`}
            className="press flex h-12 items-center justify-center gap-2 rounded-md border-2 border-ink text-sm font-semibold hover:bg-zinc-50">
            <ImagePlus className="h-4 w-4" /> Galeri
          </button>
        </div>
      )}
      <input ref={camRef} type="file" accept="image/*" capture="environment" className="hidden" data-testid={`${testid}-camera-input`}
        onChange={(e) => { upload(e.target.files); e.target.value = ""; }} />
      <input ref={galRef} type="file" accept="image/*" multiple className="hidden" data-testid={`${testid}-file-input`}
        onChange={(e) => { upload(e.target.files); e.target.value = ""; }} />
      <p className="mt-1.5 text-[11px] text-zinc-500">{value.length}/{max} foto · waktu upload & pengunggah tercatat otomatis</p>
    </div>
  );
}
